RangeSliderService.SERVICE_NAME = 'rangeSliderService';
export default function RangeSliderService(
    $rootScope,
    $timeout,
    userService,
) {
    'ngInject';

    return {
        priceTranslate,
        timeTranslate,
        durationTranslate,
        forceRenderSlider,
    };

    function priceTranslate(value) {
        const {currencySign} = userService.getRegionalSettings();
        return `${currencySign}${value}`;
    }

    function timeTranslate(value) {
        return value >= 10 ? `${value}:00` : `0${value}:00`;
    }

    function durationTranslate(value) {
        let days = moment.duration(value).days();
        days = days === 0 ? '' : `${days}d`;
        const hours = moment.duration(value).hours();
        const minutes = moment.duration(value).minutes();
        return `${days} ${hours}h ${minutes}m`;
    }

    function forceRenderSlider() {
        $timeout(() => $rootScope.$broadcast('rzSliderForceRender'));
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/range-slider/range-slider-service.js